import { radarImagesCollection } from '../../store/modules/mrms/utils/mrmsImageCollection';

const getMrmsImages = () => radarImagesCollection;

export {
  getMrmsImages,
};
